module.exports = "/virtual-football-league/img/video/vvb-header.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/vvb-header.png
// module id = 365
// module chunks = 4